import { I18N } from 'aurelia-i18n';
import { DigitalWalletType } from '../../models/digital-wallet';
import { State } from '../../services/global-state';

export abstract class DigitalWalletSettings {
	private digitalWalletType: DigitalWalletType = DigitalWalletType.NotSet;

	constructor(
		protected i18n: I18N,
		protected globalState: State,
		digitalWalletType: DigitalWalletType) {
		this.digitalWalletType = digitalWalletType;
	}

	isApplePay(): boolean {
		return this.digitalWalletType === DigitalWalletType.ApplePay;
	}

	isCard(): boolean {
		return this.digitalWalletType === DigitalWalletType.ApplePay;
	}

	getDigitalWalletType(): DigitalWalletType {
		return this.digitalWalletType;
	}

	getDigitalWalletName(): string {
		switch (this.digitalWalletType) {
			case DigitalWalletType.ApplePay:
				return 'Apple Pay';
			default:
				return 'Not Set';
		}
	}
}
